"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ProcessedResponse = exports.NetworkManager = exports.D_Processed_Response = void 0;
var _commonLib = require("@caps-mobile/common-lib");
var _enums = require("./enums");
var _constants = require("./constants");
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
;
var ProcessedResponse = /*#__PURE__*/function () {
  function ProcessedResponse() {
    var init = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : D_Processed_Response;
    _classCallCheck(this, ProcessedResponse);
    _defineProperty(this, "xChecksum", void 0);
    _defineProperty(this, "xCount", void 0);
    _defineProperty(this, "status", void 0);
    _defineProperty(this, "data", void 0);
    _defineProperty(this, "error", void 0);
    this.xChecksum = init.xChecksum;
    this.xCount = init.xCount;
    this.status = init.status;
    this.data = init.data;

    // we do not know if the init object contains an Error, an errorMessage, or null
    var error = init.error;
    var errorMessage = init.errorMessage;

    // so we check what is present, and assign the appropriate value
    this.error = error ? error : errorMessage ? new Error(errorMessage) : null;
  }
  _createClass(ProcessedResponse, [{
    key: "parseHeadersCount",
    value: function parseHeadersCount(headers) {
      var countStr = headers.get("x-total-count") || "0";
      return parseInt(countStr);
    }
  }, {
    key: "parseHeadersChecksum",
    value: function parseHeadersChecksum(headers) {
      return headers.get("x-checksum") || "";
    }
  }, {
    key: "extractCountAndChecksum",
    value: function extractCountAndChecksum(headers) {
      this.xChecksum = this.parseHeadersChecksum(headers);
      this.xCount = this.parseHeadersCount(headers);
    }
  }, {
    key: "getCount",
    value: function getCount() {
      return this.xCount;
    }
  }, {
    key: "getChecksum",
    value: function getChecksum() {
      return this.xChecksum;
    }
  }, {
    key: "getReduxObject",
    value: function getReduxObject() {
      return {
        xChecksum: this.getChecksum(),
        xCount: this.getCount(),
        status: this.status,
        data: this.data,
        errorMessage: this.error ? this.error.message : ""
      };
    }
  }, {
    key: "isCountEqual",
    value: function isCountEqual(givenValue) {
      // if the given value is UoN, check for UoN equvialence first
      if (!(0, _commonLib.nuon)(givenValue)) return !(0, _commonLib.nuon)(this.getCount());

      // then parse the givenCount if necessary
      var parsedValue = typeof givenValue === "string" ? parseInt(givenValue) : givenValue;
      return parsedValue === this.getCount();
    }
  }, {
    key: "isChecksumEqual",
    value: function isChecksumEqual(givenValue) {
      return givenValue === this.getChecksum();
    }
  }]);
  return ProcessedResponse;
}();
exports.ProcessedResponse = ProcessedResponse;
;
var D_Processed_Response = {
  xChecksum: "",
  xCount: 0,
  status: 0,
  data: null,
  error: null
};
exports.D_Processed_Response = D_Processed_Response;
var NetworkManager = /*#__PURE__*/_createClass(function NetworkManager(_requestUrl) {
  var _this = this;
  _classCallCheck(this, NetworkManager);
  _defineProperty(this, "requestUrl", void 0);
  _defineProperty(this, "accessToken", void 0);
  _defineProperty(this, "customFetch", function (requestInfo, requestInit) {
    return fetch(requestInfo, requestInit);
  });
  _defineProperty(this, "authorizedFetch", function (requestInfo, requestInit) {
    var _requestInit;
    // create the headers property object for requestInit
    var headersInit = {
      //the default header construct for api calls
      "Authorization": "Bearer ".concat(_this.accessToken),
      //the auth token supplied by setter function
      "mode": "cors",
      //cross-origin allowed
      "credentials": "include" //value 'include' allows credentials to be sent even if using cross-origin url
    };

    // add authorization properties to init.headers
    requestInit = _objectSpread(_objectSpread({}, requestInit), {}, {
      headers: new Headers(_objectSpread(_objectSpread({}, (_requestInit = requestInit) === null || _requestInit === void 0 ? void 0 : _requestInit.headers), headersInit))
    });
    return _this.customFetch(requestInfo, requestInit);
  });
  _defineProperty(this, "processedFetch", function (requestInfo, requestInit) {
    var authorized = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    return new Promise(function (resolve, reject) {
      var responsePromise;
      var processedResponse = new ProcessedResponse();

      // make authorized or standard fetch accordingly
      if (authorized) responsePromise = _this.authorizedFetch(requestInfo, requestInit);else responsePromise = _this.customFetch(requestInfo, requestInit);
      responsePromise.then(function (response) {
        // extract headers
        processedResponse.extractCountAndChecksum(response.headers);

        // extract status code
        processedResponse.status = response.status;

        // check for a bad response/error
        processedResponse.error = _this.checkForBadResponse(response);

        // if there was an error
        if (processedResponse.error) {
          console.error("Error received bad response for: ".concat(_this.requestUrl), processedResponse.error);
          processedResponse.data = null;
          resolve(processedResponse);
        }

        // if it was a head-only request, don't bother unpacking data
        else if ((requestInit === null || requestInit === void 0 ? void 0 : requestInit.method) === _enums.EHttpRequestMethod.HEAD) {
          processedResponse.data = null;
          resolve(processedResponse);
        } else if (response.status === 204) {
          processedResponse.data = null;
          resolve(processedResponse);
        }

        // otherwise, we proceed to extract the data from the response
        else {
          // if response content type is valid, process the data and update response object
          var contentType = response.headers.get("content-type") || "";
          if (contentType && _this.isValidContentType(contentType)) {
            if (contentType === "image/jpeg") {
              response.blob().then(function (data) {
                processedResponse.data = URL.createObjectURL(data);
                processedResponse.error = null;
                resolve(processedResponse);
              }).catch(function (error) {
                console.error("Error caught during response JSON processing for: ".concat(_this.requestUrl), requestInit, error);
                processedResponse.data = null;
                processedResponse.error = error;
                resolve(processedResponse);
              });
            } else {
              response.json().then(function (data) {
                processedResponse.data = data;
                processedResponse.error = null;
                resolve(processedResponse);
              }).catch(function (error) {
                console.error("Error caught during response JSON processing for: ".concat(_this.requestUrl), requestInit, error);
                processedResponse.data = null;
                processedResponse.error = error;
                resolve(processedResponse);
              });
            }
          } else {
            // let contentTypeError: Error = 
            //     new Error(`The response content type was missing or invalid: ${contentType}`);

            processedResponse.data = null;
            //processedResponse.error = contentTypeError;
            processedResponse.error = null;
            resolve(processedResponse);
          }
        }
      }).catch(function (error) {
        console.error("Error caught during response Promise processing for: ".concat(_this.requestUrl), error);
        processedResponse.data = null;
        processedResponse.error = error;
        resolve(processedResponse);
      });
    });
  });
  _defineProperty(this, "getData", function (requestInfo, requestInit, currentResponse) {
    var authorized = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    return new Promise(function (resolve, reject) {
      var currentCount = 0;
      var currentChecksum = "";
      if (currentResponse) {
        currentCount = currentResponse.getCount();
        currentChecksum = currentResponse.getChecksum();
      }

      // get the corresponding HEAD response
      _this.processedFetch(requestInfo, _objectSpread(_objectSpread({}, requestInit), {}, {
        method: _enums.EHttpRequestMethod.HEAD
      }), authorized).then(function (processedResponse) {
        var newCount = processedResponse.getCount();
        var newChecksum = processedResponse.getChecksum();

        // if this was a headOnly request, we can resolve now.
        if (requestInit !== null && requestInit !== void 0 && requestInit.method && requestInit.method === _enums.EHttpRequestMethod.HEAD) resolve(processedResponse);

        // if this response was a 204, we can just return it as is
        else if (processedResponse.status === 204) resolve(new ProcessedResponse(processedResponse));

        // else, we need to check for a head change and get new data if appropriate
        else {
          // if change has occurred, make a new request and resolve with it
          if (newCount !== currentCount || currentChecksum !== newChecksum) {
            resolve(_this.processedFetch(requestInfo, requestInit, authorized));
          } else {
            resolve(currentResponse || new ProcessedResponse(processedResponse));
          }
        }
      });
    });
  });
  _defineProperty(this, "checkForBadResponse", function (response) {
    var status = response.status;
    var statusText = response.statusText;
    if (status >= 300) {
      return new Error("Received a bad response: ".concat(status, "\n ").concat(statusText, "\n for ").concat(_this.requestUrl, "\n"));
    } else return null;
  });
  _defineProperty(this, "appendUrlParameters", function (requestUrl, urlParameters) {
    var newRequestUrl = requestUrl; //create a copy of the request url to manipulate and return

    if (urlParameters.length > 0) {
      //if there are urlParameters...
      newRequestUrl += "?".concat(urlParameters[0]); //append the first one with the ? character
      if (urlParameters.length > 1) {
        //if there are more urlParameters...
        for (var i = 1; i < urlParameters.length; i++) {
          newRequestUrl += "&".concat(urlParameters[i]); //append the rest of them with the & character
        }
      }
    }

    return newRequestUrl; //finally, return the new, full request string
  });
  _defineProperty(this, "paramsObjectToArray", function (requestParams) {
    if (!requestParams) return [];
    var paramsArray = [];
    Object.keys(requestParams).map(function (key) {
      if (Array.isArray(requestParams[key])) {
        requestParams[key].map(function (keyOfKey) {
          if (keyOfKey) {
            paramsArray.push("".concat(key, "=").concat(keyOfKey));
          }
        });
      } else if (_typeof(key) === 'object') paramsArray.push.apply(paramsArray, _toConsumableArray(_this.paramsObjectToArray(key)));else if (requestParams[key]) {
        paramsArray.push("".concat(key, "=").concat(requestParams[key]));
      }
    });
    return paramsArray;
  });
  _defineProperty(this, "setRequestUrl", function (newRequestUrl) {
    _this.requestUrl = newRequestUrl;
  });
  _defineProperty(this, "setAccessToken", function (newToken) {
    _this.accessToken = newToken;
  });
  _defineProperty(this, "isValidContentType", function (contentType) {
    for (var i = 0; i < _constants.validResponseContentTypes.length; i++) {
      if (contentType.indexOf(_constants.validResponseContentTypes[i]) !== -1) return true;
    }
    return false;
  });
  this.requestUrl = _requestUrl;
  this.accessToken = "";
});
exports.NetworkManager = NetworkManager;
var _default = NetworkManager;
exports.default = _default;